<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-icon>mdi-plus</v-icon><span class="headerTitle">{{ labels.cargoTitle }}</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <!-- vesNo: 'Vessel No.',
        vesName: 'Vessel Name',
        voyNo: 'Voyage No',
        -->
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesNo }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.vesName }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.voyNo }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.vesNo }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.vesName }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ cargoRisk.voyNo }} - {{ cargoRisk.voyNoDesc }}</div>
              </v-flex>
              <!-- voyDate: 'Voyage Date',
        voyDateType: 'Voyage Date Type',
        voyArea: 'Voyage Area Code', -->
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.voyDate }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.voyDateType }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.voyArea }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ formatDate(cargoRisk.voyDate) }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.voyDateTypeDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ cargoRisk.voyAreaDesc }}</div>
              </v-flex>
              <!-- portDep: 'Voyage From',
        portArr: 'Voyage To',
        voyDesc: 'Voyage Description', -->
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.portDep }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.portArr }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.voyDesc }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.portDep }} - {{ cargoRisk.portDepDesc }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.portArr }} - {{ cargoRisk.portArrDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-textarea v-model="cargoRisk.voyDesc" :rows="2" readonly></v-textarea>
              </v-flex>
              <!-- coverage: 'Coverage Code',
        comdtyType: 'Commodity Code',
        pkgType: 'Packing Type', -->
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.coverage }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.comdtyType }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.pkgType }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.coverage }} - {{ cargoRisk.coverageDesc }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.comdtyType }} - {{ cargoRisk.comdtyTypeDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ cargoRisk.pkgType }} - {{ cargoRisk.pkgTypeDesc }}</div>
              </v-flex>
              <!-- surAgt: 'Survey Agent',
        setAgt: 'Settlement Agent', -->
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.surAgt }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.setAgt }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ cargoRisk.surAgt }} - {{ cargoRisk.surAgtName }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ cargoRisk.setAgt }} - {{ cargoRisk.setAgtName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-textarea v-model="cargoRisk.surAgtAddress" :rows="2" readonly></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-textarea v-model="cargoRisk.setAgtAddress" :rows="2" readonly></v-textarea>
              </v-flex>
              <!-- certBord: 'Cert/Bordereaux',
        dclrCertNo: 'Declared Certificate No.'  -->
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.certBord }}</v-subheader>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="queryLabel">{{ labels.dclrCertNo }}</v-subheader>
              </v-flex>
              <v-flex xs6> </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ formatCert(cargoRisk.certBord) }}</div>
              </v-flex>
              <v-flex xs3>
                <div class="queryValue">{{ cargoRisk.dclrCertNo }}</div>
              </v-flex>
              <v-flex xs6> </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        cargoTitle: 'Cargo Risk Details',
        vesNo: 'Vessel No.',
        vesName: 'Vessel Name',
        voyNo: 'Voyage No',
        voyDateType: 'Voyage Date Type',
        voyDate: 'Voyage Date',
        voyArea: 'Voyage Area Code',
        portDep: 'Voyage From',
        portArr: 'Voyage To',
        voyDesc: 'Voyage Description',
        coverage: 'Coverage Code',
        comdtyType: 'Commodity Code',
        pkgType: 'Packing Type',
        surAgt: 'Survey Agent',
        setAgt: 'Settlement Agent',
        certBord: 'Cert/Bordereaux',
        dclrCertNo: 'Declared Certificate No.'
      },
      cargoRisk: {
        vesNo: undefined,
        vesName: undefined,
        voyNo: undefined,
        voyDateType: undefined,
        voyDate: undefined,
        voyArea: undefined,
        portDep: undefined,
        portArr: undefined,
        voyDesc: undefined,
        coverage: undefined,
        comdtyType: undefined,
        pkgType: undefined,
        surAgt: undefined,
        setAgt: undefined,
        certBord: undefined,
        dclrCertNo: undefined,
        voyNoDesc: undefined,
        voyDateTypeDesc: undefined,
        voyAreaDesc: undefined,
        portDepDesc: undefined,
        portArrDesc: undefined,
        coverageDesc: undefined,
        comdtyTypeDesc: undefined,
        pkgTypeDesc: undefined,
        surAgtName: undefined,
        surAgtAddress: undefined,
        setAgtName: undefined,
        setAgtAddress: undefined
      }
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    formatDate(xDate) {
      if (xDate === null || xDate === undefined) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    doInit() {
      this.getPolCargoRisk()
    },
    async getPolCargoRisk() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.polCargoRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polCargoRisk) {
            this.cargoRisk.vesNo = result.data.polCargoRisk.data.vesNo
            this.cargoRisk.vesName = result.data.polCargoRisk.data.vesName
            this.cargoRisk.voyNo = result.data.polCargoRisk.data.voyNo
            this.cargoRisk.voyDateType = result.data.polCargoRisk.data.voyDateType
            this.cargoRisk.voyDate = result.data.polCargoRisk.data.voyDate
            this.cargoRisk.voyArea = result.data.polCargoRisk.data.voyArea
            this.cargoRisk.portDep = result.data.polCargoRisk.data.portDep
            this.cargoRisk.portArr = result.data.polCargoRisk.data.portArr
            this.cargoRisk.voyDesc = result.data.polCargoRisk.data.voyDesc
            this.cargoRisk.coverage = result.data.polCargoRisk.data.coverage
            this.cargoRisk.comdtyType = result.data.polCargoRisk.data.comdtyType
            this.cargoRisk.pkgType = result.data.polCargoRisk.data.pkgType
            this.cargoRisk.surAgt = result.data.polCargoRisk.data.surAgt
            this.cargoRisk.setAgt = result.data.polCargoRisk.data.setAgt
            this.cargoRisk.certBord = result.data.polCargoRisk.data.certBord
            this.cargoRisk.dclrCertNo = result.data.polCargoRisk.data.dclrCertNo
            this.cargoRisk.voyNoDesc = result.data.polCargoRisk.data.voyNoDesc
            this.cargoRisk.voyDateTypeDesc = result.data.polCargoRisk.data.voyDateTypeDesc
            this.cargoRisk.voyAreaDesc = result.data.polCargoRisk.data.voyAreaDesc
            this.cargoRisk.portDepDesc = result.data.polCargoRisk.data.portDepDesc
            this.cargoRisk.portArrDesc = result.data.polCargoRisk.data.portArrDesc
            this.cargoRisk.coverageDesc = result.data.polCargoRisk.data.coverageDesc
            this.cargoRisk.comdtyTypeDesc = result.data.polCargoRisk.data.comdtyTypeDesc
            this.cargoRisk.pkgTypeDesc = result.data.polCargoRisk.data.pkgTypeDesc
            this.cargoRisk.surAgtName = result.data.polCargoRisk.data.surAgtName
            this.cargoRisk.surAgtAddress = this.displaySurAgtAddress(result.data.polCargoRisk.data)
            this.cargoRisk.setAgtName = result.data.polCargoRisk.data.setAgtName
            this.cargoRisk.setAgtAddress = this.displaySetAgtAddress(result.data.polCargoRisk.data)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    displaySurAgtAddress(data) {
      if (data) {
        var surAgtAddr = ''
        if (data.surAgtAddress1 !== undefined && data.surAgtAddress1 !== null && data.surAgtAddress1 !== '') {
          surAgtAddr = data.surAgtAddress1
        }
        if (data.surAgtAddress2 !== undefined && data.surAgtAddress2 !== null && data.surAgtAddress2 !== '') {
          surAgtAddr = surAgtAddr + ', ' + data.surAgtAddress2
        }
        if (data.surAgtAddress3 !== undefined && data.surAgtAddress3 !== null && data.surAgtAddress3 !== '') {
          surAgtAddr = surAgtAddr + ', ' + data.surAgtAddress3
        }
        if (data.surAgtAddress4 !== undefined && data.surAgtAddress4 !== null && data.surAgtAddress4 !== '') {
          surAgtAddr = surAgtAddr + ', ' + data.surAgtAddress4
        }
        if (data.surAgtPostalCode !== undefined && data.surAgtPostalCode !== null && data.surAgtPostalCode !== '') {
          surAgtAddr = surAgtAddr + ' ' + data.surAgtPostalCode
        }
        return surAgtAddr
      } else {
        return ''
      }
    },
    displaySetAgtAddress(data) {
      if (data) {
        var setAgtAddr = ''
        if (data.setAgtAddress1 !== undefined && data.setAgtAddress1 !== null && data.setAgtAddress1 !== '') {
          setAgtAddr = data.setAgtAddress1
        }
        if (data.setAgtAddress2 !== undefined && data.setAgtAddress2 !== null && data.setAgtAddress2 !== '') {
          setAgtAddr = setAgtAddr + ', ' + data.setAgtAddress2
        }
        if (data.setAgtAddress3 !== undefined && data.setAgtAddress3 !== null && data.setAgtAddress3 !== '') {
          setAgtAddr = setAgtAddr + ', ' + data.setAgtAddress3
        }
        if (data.setAgtAddress4 !== undefined && data.setAgtAddress4 !== null && data.setAgtAddress4 !== '') {
          setAgtAddr = setAgtAddr + ', ' + data.setAgtAddress4
        }
        if (data.setAgtPostalCode !== undefined && data.setAgtPostalCode !== null && data.setAgtPostalCode !== '') {
          setAgtAddr = setAgtAddr + ' ' + data.setAgtPostalCode
        }
        return setAgtAddr
      } else {
        return ''
      }
    },
    formatCert(data) {
      if (data === 'C') {
        return 'C - Individual Certificate'
      } else if (data === 'B') {
        return 'B - Bordereaux'
      } else {
        return ''
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
